import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer__content">
          <div className="footer__section">
            <h3 className="footer__title">Social Recruiting Berlin</h3>
            <p className="footer__description">
              Die #1 Social Recruiting Agentur in Berlin seit 2009.
              Spezialisiert auf Mitarbeitergewinnung über Social Media.
            </p>
            <address className="footer__address">
              Schliemannstraße 23<br />
              10437 Berlin<br />
              Deutschland
            </address>
            <div className="footer__contact">
              <a href="tel:+4930403665430" className="footer__phone">030 403 665 430</a>
              <a href="mailto:info@famefact.com" className="footer__email">
                info@famefact.com
              </a>
            </div>
          </div>

          <div className="footer__section">
            <h3 className="footer__title">Services</h3>
            <ul className="footer__links">
              <li>
                <Link 
                  to="/leistungen" 
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Leistungen Übersicht
                </Link>
              </li>
              <li>
                <Link to="/leistungen/instagram-recruiting">Instagram Recruiting</Link>
              </li>
              <li>
                <Link to="/leistungen/linkedin-recruiting">LinkedIn Recruiting</Link>
              </li>
              <li>
                <Link to="/leistungen/tiktok-recruiting">TikTok Recruiting</Link>
              </li>
              <li>
                <Link to="/leistungen/social-media-strategie">Social Media Strategie</Link>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__title">Branchen</h3>
            <ul className="footer__links">
              <li>
                <Link 
                  to="/branchen"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Branchen Übersicht
                </Link>
              </li>
              <li>
                <Link to="/branchen/it-tech">IT & Technology</Link>
              </li>
              <li>
                <Link to="/branchen/logistik-handel">Logistik & Handel</Link>
              </li>
              <li>
                <Link to="/branchen/gastronomie">Gastronomie</Link>
              </li>
              <li>
                <Link to="/branchen/startups">Start-ups</Link>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__title">Unternehmen</h3>
            <ul className="footer__links">
              <li><a href="/blog/">Blog</a></li>
              <li>
                <a href="#" data-open-consultation data-source="Footer CTA">
                  Kostenloses Erstgespräch
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__legal">
            <a href="/impressum/">Impressum</a>
            <a href="/datenschutz/">Datenschutz</a>
            <a href="/agb/">AGB</a>
          </div>
          <div className="footer__social">
            <a 
              href="https://linkedin.com/company/famefact" 
              className="social-link" 
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="icon" viewBox="0 0 24 24">
                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
              </svg>
            </a>
            <a 
              href="https://instagram.com/famefact" 
              className="social-link" 
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="icon" viewBox="0 0 24 24">
                <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
              </svg>
            </a>
          </div>
          <div className="footer__copyright">
            <p>&copy; 2025 Social Recruiting Berlin. Alle Rechte vorbehalten.</p>
            <p className="powered-by">
              powered by <a href="https://famefact.com/recrutainment/" target="_blank" rel="noopener noreferrer"><strong>famefact</strong></a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
